/**
 * Common Service class for common functions
 * Modified on 09-08-2024
 */

import { appInsights } from "../config/appInsights";
import store from "../redux/store";

class CommonService {
  constructor() {

    this.apiHostEnv = process.env.REACT_APP_HOSTING_ENV;

    this.webApiEndpoint = process.env.REACT_APP_WEB_API_ENDPOINT;

    this.webApiEndpointAU = process.env.REACT_APP_WEB_API_ENDPOINT_AU;
    this.webApiEndpointEU = process.env.REACT_APP_WEB_API_ENDPOINT_EU;
    this.webApiEndpointUS = process.env.REACT_APP_WEB_API_ENDPOINT_US;

    //  Headers
    this.headers = { "Content-type": "application/json; charset=UTF-8" };

    //  API url methods
    this.apiUrl = {
      getReferences: '/getGroupKey'
    }

    //  List of API endpoints to point to local mock data
    this.mockApiUrl = [
      // 
    ]
  }
  logException(error, componentName, methodName, requestObject=null, userId=null) {
    appInsights.trackException({
      error: error,
      properties: {
        Component: componentName,
        Method: methodName,
        UserId: userId,
        payload: requestObject,
        errorData:error?.response?.data
      },
    });
  }

  /**
   * Get API url
   * @returns 
   */
  getAPIUrl() {
    const vDataHostingLocation = store.getState().user?.activeProject?.dataHostingLocation;
    if (this.apiHostEnv === "UAT" || this.apiHostEnv === "PROD") {
      if (vDataHostingLocation === '1') {
        return this.webApiEndpointUS;
      } else if (vDataHostingLocation === '2') {
        return this.webApiEndpointEU;
      } else {
        return this.webApiEndpointAU;
      }
    } else {
      return this.webApiEndpoint;
    }
  }
}
export default CommonService;
